import { render, staticRenderFns } from "./popperBackground.vue?vue&type=template&id=3453265a"
import script from "./popperBackground.vue?vue&type=script&lang=js"
export * from "./popperBackground.vue?vue&type=script&lang=js"
import style0 from "./popperBackground.vue?vue&type=style&index=0&id=3453265a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports